// NodeDateField.jsx

import React from 'react';

// CSS
import './NodeDateField.css';

// Components
import NodeDateInput from 'node/form/fields/date/NodeDateInput';
import NodeTemporalReadOnlyValue from 'node/form/fields/utilities/NodeTemporalReadOnlyValue';

/**
 * NodeDateField
 *
 * Displays a schema-driven date field with a segmented date input.
 * In readOnly / previewMode: friendly label (e.g. Jul 31, 2026).
 *
 * @param {object} value - Current field value.
 * @param {Function} onChange - Callback when new dates are saved.
 * @param {boolean} [readOnly=false]
 * @param {boolean} [previewMode=false]
 *
 * @returns {ReactNode} NodeDateField component.
 */
const NodeDateField = ({
  value,
  onChange,
  readOnly = false,
  previewMode = false,
}) => {
  const isReadOnly = Boolean(readOnly || previewMode);

  if (isReadOnly) {
    return (
      <div className="node-date-field-container is-readonly">
        <NodeTemporalReadOnlyValue value={value} fieldType="date" />
      </div>
    );
  }

  return (
    <div className="node-date-field-container">
      <NodeDateInput
        className="node-date-field-picker"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

NodeDateField.displayName = 'NodeDateField';

export default NodeDateField;
